<template>
  <span v-if="layer">
    <PrintButtonBase
      v-for="p in prints"
      v-bind:key="p"
      cta=""
      :linkHref="printUrl(p)"
      linkAlt="Vytisknout výkres vrstvy"
      :tooltip="layouts[p].name"
      :icon="layouts[p].icon"
    />
  </span>
</template>

<script>
import { DRAWING_PRINT_BASE_URL } from '@/constants/global';
import PrintButtonBase from './PrintButtonBase';

export default {
  props: {
    layer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      layouts: {
        'A3-CaptionOnSide': {
          name: 'A3 - s legendou na straně',
          icon: 'A3'
        },
        'A3-MapOnly': {
          name: 'A3 - Mapa na celou stránku',
          icon: 'A3'
        },
        A4: {
          name: 'A4 - Schéma',
          icon: 'A4'
        },
        l1_w840_h1650: {
          name: '1 - 840 x 1650 mm',
          icon: 'l1_w840_h1650'
        },
        l2_w630_h1500: {
          name: '2 - 630 x 1500 mm',
          icon: 'l2_w630_h1500'
        },
        l3_w840_h1500: {
          name: '3 - 840 x 1500 mm',
          icon: 'l3_w840_h1500'
        },
        w730_h1260: {
          name: '1260 x 730 mm - 1:10 000',
          icon: 'w730_h1260'
        },
        w900_h830: {
          name: '900 x 830 mm - 1:5000',
          icon: 'w900_h830'
        },
        A2: {
          name: 'A2',
          icon: 'A4'
        },
        A1: {
          name: 'A1',
          icon: 'A4'
        }
      }
    };
  },
  components: {
    PrintButtonBase
  },
  methods: {
    printUrl(printLayout) {
      return `${DRAWING_PRINT_BASE_URL}${this.layer.id}?layout=${printLayout}`;
    }
  },
  computed: {
    prints: function () {
      try {
        return JSON.parse(this.layer.prints);
      } catch (e) {
        return [];
      }
    }
  }
};
</script>

<style scoped></style>
